import { useEffect } from "react";

export default function SelectInput({ question, value, onChange, error }) {
  const realOptions = question.options.filter((o) => o.value !== "");

  useEffect(() => {
    if (realOptions.length === 1 && !value) {
      onChange(question.id, realOptions[0].value);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex flex-col gap-2">
      <div className="relative">
        <select
          value={value || ""}
          onChange={(e) => onChange(question.id, e.target.value)}
          className={`w-full px-5 py-3.5 rounded-xl bg-white/5 border text-white
            font-sans text-sm desktop:text-base outline-none transition-all duration-300
            focus:bg-white/10 focus:ring-2 focus:ring-white/20 appearance-none cursor-pointer
            ${!value ? "text-white/40" : ""}
            ${error ? "border-red" : "border-white/20 focus:border-white/40"}`}
        >
          {question.options.map((opt) => (
            <option
              key={opt.value}
              value={opt.value}
              className="bg-midnight text-white"
            >
              {opt.label}
            </option>
          ))}
        </select>
        <i className="fa-solid fa-chevron-down absolute right-4 top-1/2 -translate-y-1/2 text-white/40 pointer-events-none text-xs" />
      </div>
    </div>
  );
}
